import React, { useCallback, useEffect, useRef, useState } from "react";
import { useApi } from "../../Helpers/ApiHook";
import { useParams } from "react-router-dom";
import { getFullName } from "../../Helpers/Functions";
import { ProfileSkeletonLoader } from "./components";
import CertificateSample from "../ServicePage/components/CertificateSample";
import NeedHelp from "../ServicePage/components/NeedHelp";
import { YoutubeGallery } from "../../Components/YoutubeGallery";
import { PageDataErrorBox, ShareButton } from "../../Components";



// const certifications = [
//     "Certified Personal Trainer",
//     "Specialist Fitness Trainer",
//     "Certified Wolly Instructor",
//     "Certified Vegan Nutritonist"
// ];

// const specializations = [
//     "Home Workout",
//     "Strength Training",
//     "Sports Nutrition",
//     "Wegthlifting",
//     "Powerlifting",
//     "HIIT",
//     "Yoga",
//     "Functional Traning",
//     "Mat Pilates",
//     "Clinical Nutrition",
//     "Women Health Specialization",
//     "Sports Training"
// ]

// const our_services = [
//     {
//         title: "Online Fitness Consultation",
//         channel: "YouTube",
//         thumbnail: "https://i.ytimg.com/vi/2pLT-olgUJs/hqdefault.jpg",
//         price: "3999",
//     },
//     {
//         title: "Personal Training (Online & Offline)",
//         channel: "YouTube",
//         thumbnail: "https://i.ytimg.com/vi/q6XUWrYbtps/hqdefault.jpg",
//         price: "8999",
//     },
//     {
//         title: "Nutrition Consultation (Online)",
//         channel: "YouTube",
//         thumbnail: "https://i.ytimg.com/vi/ml6cT4AZdqI/hqdefault.jpg",
//         price: "3999",
//     },
//     {
//         title: "30-Day Fitness Challenge",
//         channel: "YouTube",
//         thumbnail: "https://i.ytimg.com/vi/SfEkboNXMFw/hqdefault.jpg",
//         price: "3999",
//     },
//     {
//         title: "90-Day Transformation Program",
//         channel: "YouTube",
//         thumbnail: "https://i.ytimg.com/vi/SfEkboNXMFw/hqdefault.jpg",
//         price: "3999",
//     },
//     {
//         title: "Group Fitness Classes (Functional Training / Pilates / Yoga)",
//         channel: "YouTube",
//         thumbnail: "https://i.ytimg.com/vi/SfEkboNXMFw/hqdefault.jpg",
//         price: "3999",
//     },
// ]

// const youtube_links = [
//     {
//         title: "30 Min FULL BODY WORKOUT with WARM UP |...",
//         channel: "YouTube",
//         link: "https://www.youtube.com/watch?v=2pLT-olgUJs",
//         views: "300",
//     },
//     {
//         title: "LOSE BELLY FAT in 7 Days Challenge | Lose...",
//         channel: "YouTube",
//         link: "https://www.youtube.com/watch?v=q6XUWrYbtps",
//         views: "80 MILLION+ VIEWS",
//     },
//     {
//         title: "20 Min Fat Burning HIIT Workout - Full Body",
//         channel: "YouTube",
//         link: "https://www.youtube.com/watch?v=ml6cT4AZdqI",
//         views: "300 CALORIES",
//     },
//     {
//         title: "LOSE BELLY FAT in 7 Days",
//         channel: "YouTube",
//         link: "https://www.youtube.com/watch?v=SfEkboNXMFw",
//         views: "30",
//     },
// ];


const TrainerProfile = () => {

    const params = useParams();

    const trainerId = params?.trainerId || null;

    const { get } = useApi()

    const [isLoading, setIsLoading] = useState(true);
    const [trainerDetails, setTrainerDetails] = useState({});

    const hasFetchedRef = useRef(false);

    const _getTrainers = useCallback(async () => {
        setIsLoading(true);
        try {
            const data = await get(`trainers/show/${trainerId}`);
            if (data?.status) {
                setTrainerDetails(data?.data || null);
            }
        } catch (error) {
            console.error("Error fetching trainers: ", error);
        } finally {
            setIsLoading(false);
        }
    }, [get, trainerId]);

    useEffect(() => {
        if (!trainerId) return;

        if (!hasFetchedRef.current) {
            hasFetchedRef.current = true;
            _getTrainers();
        }
    }, [trainerId, _getTrainers])

    if (isLoading) {
        return (
            <ProfileSkeletonLoader />
        )
    }

    if (!isLoading && !trainerDetails?.id) {
        return (
            <PageDataErrorBox
                prefixTitle="trainer"
            />
        )
    }

    const whatsapp_msg = "Hello Trainer, I'm interested in your training programs. Can you please share more details?";

    const social_links_api = (trainerDetails?.social_links || {});

    const social_media_links = [
        {
            name: "facebook",
            link: social_links_api.facebook || "",
            image: "/assets/individual/social-media/facebook.png"
        },
        {
            name: "youtube",
            link: social_links_api.youtube || "",
            image: "/assets/individual/social-media/youtube.png"
        },
        {
            name: "linkedin",
            link: social_links_api.linkedin || "",
            image: "/assets/individual/social-media/linkedin.png"
        },
        {
            name: "instagram",
            link: social_links_api.instagram || "",
            image: "/assets/individual/social-media/instagram.png"
        }
    ]

    const specializations = (trainerDetails?.specialization_tags || [])
    const certifications = (trainerDetails?.certification_tags || [])
    const our_services = trainerDetails?.services || [];

    const SocialLinks = () => {
        return (
            <div className="flex gap-3 mt-2 text-lg">
                {
                    (social_media_links).map((link, index) => {
                        return (
                            <a href={link.link} target="_black" rel="noreferrer" className="" key={index}>
                                <img className="h-8 w-8" src={link.image} alt={link.name} />
                            </a>
                        )
                    })
                }
            </div>
        )
    }

    const languages = (trainerDetails?.languages || []);

    const TagCard = ({ title = "", tags = [], isIconVisible = false }) => {
        return (
            <div className='w-full md:w-1/2 flex flex-col items-center py-3'>
                <div className='w-full flex flex-col items-center mb-4'>
                    {
                        <div className='bg-white shadow-[0px_0px_5px_5px_rgba(171,198,248,0.5)] transition-shadow px-8 py-1 rounded-full text-neutral-950 font-semibold font-inter text-sm sm:text-md lg:text-2xl italic leading-6 lg:leading-10'>
                            {title}
                        </div>
                    }
                    {/* <h2
                        className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-center">
                        {title || ""}
                    </h2> */}
                </div>
                <div className="flex flex-row flex-wrap justify-center md:justify-start items-center gap-6 px-0 md:py-4 md:px-4 mx-auto">
                    {
                        tags.map((tagName, index) => {
                            const radiusClass = 'rounded-tl-md';
                            return (
                                <div
                                    key={index}
                                    className={`flex bg-gradient-radial flex-row items-center px-3 py-2 md:py-2 rounded-3xl ${radiusClass} border border-white gap-3 transition-transform hover:scale-105`}
                                >
                                    {
                                        isIconVisible &&
                                        <img className="h-5 w-5" src="/assets/individual/certificate.png" alt="certificate-icon" />
                                    }
                                    <h3 className="text-white text-[1rem] sm:text-[0.9rem] font-semibold font-poppins leading-normal">
                                        {(tagName || "").trim("")}
                                    </h3>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }

    const _getWhatsAppMsg = (msg = "") => {

        const message = `https://wa.me/91${trainerDetails?.whatsapp_no || trainerDetails?.phone_no || "0000000000"}?text=${encodeURIComponent(msg)}`
        return message;

    }

    const ButtonAndDetails = () => {
        return (
            <div className="w-full flex flex-col justify-center items-center">
                {/* Buttons */}
                <div className="w-full flex lg:flex-row flex-col-reverse justify-between items-center sm:items-start gap-3">
                    <div className="flex flex-wrap gap-3 my-2 sm:my-2 lg:my-6">
                        {
                            [
                                {
                                    name: "Call",
                                    image: '/assets/individual/Call.png',
                                    link: `tel:${trainerDetails?.phone_no}`
                                },
                                {
                                    name: "WhatsApp",
                                    image: '/assets/individual/WhatsApp.png',
                                    link: `${_getWhatsAppMsg(whatsapp_msg)}`
                                },
                                {
                                    name: "Mail",
                                    image: '/assets/individual/Mail.png',
                                    link: `mailto:${trainerDetails?.email || ""}?subject=${encodeURIComponent("Training Inquiry")}&body=${encodeURIComponent("Hello Trainer, I'm interested in your training programs. Can you please share more details?")}`
                                }
                            ].map((buttonDetails, index) => {
                                return (
                                    <button onClick={() => {
                                        window.open(buttonDetails?.link, "_blank")
                                    }} key={index} className="group flex items-center bg-white border border-gray-300 text-gray-900 font-medium p-[0.15rem] rounded-xl rounded-tr-lg shadow-sm hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2">
                                        <span className='px-2 font-urbanist text-sm group-hover:scale-105'>{buttonDetails.name}</span>
                                        <span className="flex items-center justify-center w-5 h-5 rounded-xl rounded-tr-md p-1 transition bg-black group-hover:scale-105">
                                            <img className="transition-transform" src={buttonDetails.image} alt={buttonDetails.name} />
                                        </span>
                                    </button>

                                )
                            })
                        }
                    </div>

                    {/* Stats */}
                    <div className="w-full sm:w-auto flex flex-wrap sm:flex-nowrap flex-row justify-between sm:gap-6 text-sm my-2 sm:my-2">
                        <div className="flex flex-col w-1/2 sm:w-auto my-2">
                            <p className="text-[0.7rem] md:text-sm text-gray-400">Years Experience</p>
                            <p className="text-[0.7] sm:text-lg font-semibold">{trainerDetails?.experience_yrs || 0}+</p>
                        </div>
                        <div className="flex flex-col w-1/2 sm:w-auto my-2">
                            <p className="text-[0.7rem] md:text-sm text-gray-400">Clients Coached</p>
                            <p className="text-[0.7] sm:text-lg font-semibold">{trainerDetails?.clients_coached || 0}+</p>
                        </div>
                        <div className="flex flex-col w-1/2 sm:w-auto my-2">
                            <p className="text-[0.7rem] md:text-sm text-gray-400">Languages Spoken</p>
                            <p className="text-[0.7] sm:text-lg font-semibold">{(languages || []).join('/')}</p>
                        </div>
                        <div className="flex flex-col w-1/2 sm:w-auto my-2">
                            <p className="text-[0.7rem] md:text-sm text-gray-400">Availability</p>
                            <p className={`text-[0.7] sm:text-lg font-semibold text-green-400`}>{trainerDetails?.availability || ""}</p>
                        </div>
                    </div>
                </div>
                {/* Social Section */}
                <div className="md:hidden flex flex-col md:items-center gap-2 mt-3 md:mt-2">
                    <SocialLinks />
                </div>
            </div>
        )
    }

    const user_name = getFullName({ first_name: trainerDetails?.first_name, last_name: trainerDetails?.last_name })

    const location = (trainerDetails?.location || {})

    const locality = `${!!location?.city ? location?.city + ', ' : ''}${!!location?.state ? location?.state + ', ' : ''}${!!location?.country ? location?.country : ''}` || "India";

    return (
        <div className="w-full bg-gradient-radial flex flex-col font-urbanist">
            <section className="w-full flex flex-col lg:pt-15 pt-16 pb-4">
                <div className="container mx-auto px-4 lg:px-10">
                    <div className="w-full text-white font-urbanist flex justify-center items-start pt-5">
                        <div className="relative w-full h-auto flex flex-col items-center rounded-tl-lg rounded-tr-lg">

                            {/* Banner (Fixed height on mobile removed for better flow) */}
                            <img
                                src={trainerDetails?.banner_img || "/assets/individual/banner.jpg"}
                                alt="Banner"
                                className="w-full h-44 sm:h-44 md:h-48 object-cover bg-gray-700 rounded-tl-lg rounded-tr-lg"
                            />

                            {/* Profile Section */}
                            <div className="w-full flex flex-col border-b-2 border-dashed pb-12">

                                {/* Profile Photo and Info Container */}
                                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 p-5 pb-2 sm:pb-5">

                                    {/* Profile Photo (FIXED positioning) */}
                                    <div className="w-36 sm:w-44 md:w-52 h-44 sm:h-56 md:h-72 rounded-xl overflow-hidden shadow-lg border border-black p-2 md:p-4 bg-[#FFFFFF0D] -mt-20 sm:-mt-24">
                                        <img
                                            src={trainerDetails?.profile_img || "/assets/individual/profile-image.png"}
                                            alt="Trainer"
                                            className="object-cover w-full h-full"
                                        />
                                    </div>

                                    <div className="w-full flex-1 flex-col pt-4">
                                        {/* Info */}
                                        <div className="w-full flex flex-row justify-between">
                                            <div className="flex flex-col">
                                                <h3 className="text-2xl font-semibold">{user_name}</h3>
                                                <p className="text-gray-400">{trainerDetails?.designation || "-"}</p>
                                                <div className="flex flex-row items-center mt-1">
                                                    <img src="/assets/gym-facilities/location.png" className="h-6 w-6" alt="location" />
                                                    <p className="text-gray-400 text-sm max-w-lg ml-2">
                                                        {locality}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex flex-col items-end justify-between py-1">
                                                <ShareButton />

                                                {/* Social Section (Desktop Only) */}
                                                <div className="hidden md:flex flex-col md:items-center gap-2 mt-3 md:mt-2">
                                                    <SocialLinks />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Buttons and Details (Desktop) */}
                                        <div className="hidden md:flex flex-col">
                                            <ButtonAndDetails />
                                        </div>
                                    </div>
                                </div>

                                {/* Buttons and Details (Mobile) - FIXED: Removed bottom-aligned elements from B&D to prevent visual conflict */}
                                <div className="md:hidden flex flex-col px-5">
                                    <ButtonAndDetails />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <section className="w-full flex items-center mt-6 lg:py-10">
                <div className="container mx-auto px-4 lg:px-10">
                    <div className='flex flex-col items-center'>
                        <div className='w-full flex flex-col items-center gap-6 mb-4'>
                            <h2
                                className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-center">
                                About Us
                            </h2>
                            <p className="w-[100%] lg:w-[40%] sm:w-[50%] text-sm text-center sm:text-xl lg:text-2xl font-urbanist text-stone-300">
                                {trainerDetails?.tagline || ""}
                            </p>
                            <p className="w-[100%] md:w-[80%] text-sm md:text-left text-center sm:text-base lg:text-md font-urbanist text-stone-300">
                                {trainerDetails?.about_description || ""}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="w-full py-3 lg:py-3 md:px-20 px-6">
                <div className="container mx-auto">
                    <div className='flex flex-col md:flex-row items-start gap-6'>
                        <TagCard
                            title="Certification"
                            tags={certifications}
                            isIconVisible={true}
                        />
                        <TagCard
                            title="Specialization"
                            tags={specializations}
                        />
                    </div>
                </div>
            </section>
            {
                !!trainerDetails?.documents?.membership_certificate_img &&
                <CertificateSample
                    isApplyGradient={false}
                    title="Membership Certificate"
                    imagePath={trainerDetails?.documents?.membership_certificate_img || " "}
                />
            }

            {/* Visual Content Section */}
            {
                !!our_services.length && (
                    <section className="w-full py-5 lg:py-10">
                        <div className="container mx-auto px-4 lg:px-24">
                            <div className='flex flex-col items-center'>
                                <div className='w-full md:w-[60%] flex flex-col items-center gap-6 mb-4'>
                                    <h2
                                        className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-center">
                                        Our Services
                                    </h2>
                                    <p className="text-sm text-center sm:text-base italic lg:text-xl font-urbanist text-stone-300">
                                        From beginners to athletes, we guide you every step—building confidence, strength, and a healthier lifestyle.
                                    </p>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-full md:max-w-6xl pt-6 pb-10">
                                    {
                                        our_services.map(({ title, img = "https://i.ytimg.com/vi/2pLT-olgUJs/hqdefault.jpg", price }, i) => {
                                            const plan_wp_msg = `Hello! I'd like to know more about the ${title} plan priced at ${price || ""}. Could you please help me with the details?`;

                                            return (
                                                <div key={i} className="flex flex-col justify-between w-full p-2 rounded-xl rounded-tl-md overflow-hidden font-urbanist shadow-md group border border-white">
                                                    <div className="w-full d-flex flex-col items-center">
                                                        <div className="w-full relative">
                                                            <img
                                                                src={img}
                                                                alt={title}
                                                                className="lg:w-96 w-full h-48 md:h-48 object-cover group-hover:brightness-75 transition rounded-tl-lg rounded-tr-lg"
                                                            />
                                                        </div>
                                                        <div className="w-full flex flex-row justify-between items-center py-2 text-left">
                                                            <div className="text-white text-sm font-urbanist">{title}</div>
                                                            <div className="font-urbanist max-w-min text-black bg-white px-2 text-sm rounded-[0.25rem] pt-[0.1rem]">
                                                                ₹{price}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="w-full flex justify-center items-center py-2">
                                                        <a href={_getWhatsAppMsg(plan_wp_msg)} className="bg-green-500 text-white text-sm px-5 py-1 rounded-md  shadow-[0px_0px_10px_0px_#FFFFFF40] hover:scale-105 font-urbanist">
                                                            <span className="font-semibold mr-1">Inquire Now</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>

                            </div>
                        </div>
                    </section>

                )
            }

            {/* Visual Content Section */}
            {
                (trainerDetails?.youtube_links || []).length > 0 && (
                    <section className="w-full py-5 lg:py-5">
                        <div className="container mx-auto px-4 lg:px-24">
                            <YoutubeGallery
                                title={'Visual Content on YouTube'}
                                tagline={'Easy-to-follow workout guides, fitness tips, and coaching videos designed to help you get stronger, healthier, and more confident every day.'}
                                items={trainerDetails?.youtube_links || []}
                            />
                        </div>
                    </section>

                )
            }

            <NeedHelp
                title="Need a Push?"
                tagline={`${user_name} — Fitness Trainer dedicated to motivating, guiding, and transforming you`}
                email={trainerDetails?.email}
                phone_no={trainerDetails?.phone_no}
            />
        </div>
    );
};


export { TrainerProfile };
